/* ============================================================
   RagHouse Boutique — PDP variant + gallery + quantity logic.
   Reads [data-rh-variant-meta], maps option selection → variant,
   updates the hidden id select, price, add button, and gallery.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-rh-pdp]').forEach(function (root) {
    var metaEl = root.querySelector('[data-rh-variant-meta]');
    if (!metaEl) return;
    var variants;
    try { variants = JSON.parse(metaEl.textContent); } catch (e) { return; }

    var idSelect = root.querySelector('[data-rh-variant-id]');
    var addBtn = root.querySelector('[data-rh-add]');
    var priceCurrent = root.querySelector('[data-rh-price-current]');
    var priceCompare = root.querySelector('[data-rh-price-compare]');
    var mainImg = root.querySelector('[data-rh-main-img]');

    // selected option values, indexed by option position - 1
    var selected = [];
    root.querySelectorAll('[data-rh-opt-group]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-rh-opt-group'), 10) - 1;
      var active = group.querySelector('.rh-active') || group.querySelector('[data-rh-opt]');
      if (active) selected[pos] = active.getAttribute('data-rh-value');
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i] == null || opt === selected[i];
        });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idSelect) idSelect.value = v.id;

      if (priceCurrent) priceCurrent.textContent = v.price;
      if (priceCompare) { priceCompare.style.display = v.compare ? '' : 'none'; if (v.compare) priceCompare.textContent = v.compare; }

      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-rh-add-default') || 'Add to Bag';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }

      if (mainImg && v.img) { mainImg.src = v.img; }
    }

    // option selection
    root.querySelectorAll('[data-rh-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-rh-opt'), 10) - 1;
        selected[pos] = btn.getAttribute('data-rh-value');
        var group = btn.closest('[data-rh-opt-group]');
        group.querySelectorAll('[data-rh-opt]').forEach(function (b) { b.classList.remove('rh-active'); });
        btn.classList.add('rh-active');
        var label = root.querySelector('[data-rh-opt-label="' + (pos + 1) + '"]');
        if (label) label.textContent = btn.getAttribute('data-rh-value');
        update();
      });
    });

    // quantity stepper
    var qtyVal = root.querySelector('[data-rh-qty-val]');
    var qtyInput = root.querySelector('[data-rh-qty-input]');
    root.querySelectorAll('[data-rh-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-rh-qty'), 10);
        var q = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = q;
        if (qtyVal) qtyVal.textContent = q;
      });
    });

    // gallery thumbnails
    root.querySelectorAll('[data-rh-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-rh-thumb');
        root.querySelectorAll('[data-rh-thumb]').forEach(function (t) { t.classList.remove('rh-active'); });
        thumb.classList.add('rh-active');
      });
    });

    update();
  });
})();
